import { useEffect, useRef } from "react";
import Swiper from "swiper";
export const useSwiper = (config, dependencies = []) => {
    const swiperInstance = useRef(null);
    const swiperRef = useRef(null);
    useEffect(() => {
        let swiper = null;
        if (swiperRef.current) {
            if (swiperInstance.current) {
                swiperInstance.current.destroy(true, true);
                swiperInstance.current = null;
            }
            swiper = new Swiper(swiperRef.current, config);
            if (config.init === false) {
                swiper.init();
            }
            swiperInstance.current = swiper;
        }
        return () => {
            if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
                swiperInstance.current = null;
            }
        };
    }, dependencies);
    const updateSwiper = () => {
        if (swiperInstance.current) {
            swiperInstance.current.update();
        }
    };
    const slideTo = (index) => {
        if (swiperInstance.current) {
            swiperInstance.current.slideTo(index);
        }
    };
    return {
        swiperRef,
        swiperInstance,
        updateSwiper,
        slideTo,
    };
};
